import { useContext } from "react";
import { useStoreUrl } from "../../../../hooks/useStoreUrl";
import { useTranslation } from "react-i18next";
import Text from "../../../molecules/content/Text";
import { getCountryCode } from "../../../../helpers/utils";
import ContactContent from "../../../molecules/contactContent/ContactContent";
import UserGreeting from "../../../molecules/content/UserGreeting";
import BrandList from "../../../organisms/brand/BrandList";
import { getBrands } from "../../../../helpers/brands";
import { useAppLinks } from "../../../../hooks/useAppLinks";
import SignOutButton from "../../../molecules/buttons/SignOutButton";
import { AuthContext } from "../../../../context/authContext";

const HomeSection = ({ attrInfo }) => {
  const { t, i18n } = useTranslation();
  const countryCode = getCountryCode();
  const { sessionInfo } = useContext(AuthContext);

  const storeUrl = useStoreUrl(i18n.language);
  const { evinAkli, vfit } = useAppLinks();
  const brands = getBrands({ t, storeUrl, evinAkli, vfit });

  const getAccessToken = () => sessionInfo?.accessToken;

  return (
    <div className="flex flex-col gap-4 pb-20">
      <UserGreeting attrInfo={attrInfo} />
      <BrandList brands={brands} getAccessToken={getAccessToken} />
      <Text variant="semibold" className="flex justify-center text-vestelColor">
        {t("home.description")}
      </Text>
      <ContactContent countryCode={countryCode} />
      <SignOutButton />
    </div>
  );
};

export default HomeSection;
